import _ from "lodash";
import api from "@/modules/exports/services/api";
import odataMixin from "@/core/store/mixin/odata";
import crudMixin from "@/core/store/mixin/crud";
import moment from "moment";

const res = _.merge({}, odataMixin(api), crudMixin(api), {
  namespaced: true,
  actions: {
    getItems({ commit }, payload) {
      return api
        .getItems({ ...payload, expand: "organization,user" })
        .then((response) => ({
          items: response.data.items,
          totalCount: response.data.count,
        }));
    },
    // eslint-disable-next-line complexity
    createRequest({ commit }, payload) {
      let url = null;
      switch (payload.type) {
        case "transactionHistoryWithEmail" : {
          url = "exports/transaction-history-with-email";
          break;
        }
        case "transactionHistoryWithPtLog" : {
          url = "exports/transaction-history-with-pt-log";
          break;
        }
        case "transactionHistoryWithPtLogFlat" : {
          url = "exports/transaction-history-with-pt-log-flat";
          break;
        }
        case "transactionHistoryWithRequestData" : {
          url = "exports/transaction-history-with-request-data";
          break;
        }
        default : url = "exports/transaction-history"
      }

      const request = {
        organizationId: payload.organizationId,
        startDate: moment(payload.dateRange.from).tz("America/Los_Angeles"),
        endDate: moment(payload.dateRange.to).tz("America/Los_Angeles"),
        name: payload.name,
      };
      return api.createRequest({ request, url });
    },
  },
});

export default res;
